import { type Model } from 'jms-domain'

import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { HandingControl } from '../controls/HandingControl'

interface AdjustableDoorWallItemPropertyPageProps {
  id: Model.AdjustableDoorCabinet['id'] | Model.BottomAdjustableDoorAppliance['id']
}

export const AdjustableDoorWallItemPropertyPage = (props: AdjustableDoorWallItemPropertyPageProps) => {
  const { id } = props

  return (
    <PropertyContainer.Group spacing="large">
      <HandingControl id={id} />
    </PropertyContainer.Group>
  )
}
